import axios from "axios";
import { API_URL } from "src/scenes/App";
import { UserKeys } from "src/constants/userDetails";
import { Toast } from "src/components";

export const getSubcategories = async () => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.get(`${API_URL}/company/bodyAndMind/subcategories`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const saveSubcategory = async (payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.post(`${API_URL}/company/bodyAndMind/subcategories`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const updateSubcategory = async (payload, categoryId) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.put(`${API_URL}/company/bodyAndMind/subcategories/${categoryId}`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const hideSubcategory = async (categoryId) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.delete(`${API_URL}/company/bodyAndMind/subcategories/${categoryId}`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    if (response.data) {
        Toast.success("Category hidden successfully");
    }
    return response.data;
};

export const showSubcategory = async (categoryId) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.put(`${API_URL}/company/bodyAndMind/subcategories/restore/${categoryId}`, {}, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    if (response.data) {
        Toast.success("Category shown successfully");
    }
    return response.data;
};

export const deleteSubcategory = async (categoryId) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.delete(`${API_URL}/company/bodyAndMind/subcategories/permanentDelete/${categoryId}`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const reOrderSubcategory = async (payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.post(`${API_URL}/company/bodyAndMind/subcategories/reorderCategories/`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};